<template>
  <div @click="handleClick"> 
    <!-- Navbar -->
    <NavbarComponent v-if="showNavbar" />

             <musicaFondo v-if="showmusicaFondo" />
    <carrusel2 v-if="showcarrusel2" />
 <imgfinal2 v-if="showimgfinal2" />

     <BienvenidaPage v-if="showBienvenida" />

 <carrusel v-if="showcarrusel" />

    <dondeycuando v-if="showdondeycuando" />
            <fondocambiante v-if="showfondocambiente" />

  <codigovestimenta v-if="showcodigovestimenta" />

    <mensajeregalos v-if="showmensajeregalos" />
            <imgfinal v-if="showimgfinal" />

    <mesaRegalos v-if="showmesaRegalos" />


    <itinerario v-if="showitinerario" />

    <InvitadoEvento 
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />

 <!-- Imagen de portada -->
  <confirmacionasistencia
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />

 <contador v-if="showcontador" />

    <imagenprimera v-if="showimagenprimera" />


    <padresevento v-if="showpadresevento" />


  
    <!-- Comprobar si idInvitado es válido antes de mostrar el componente InvitadoEvento -->
  

    <quotemensaje v-if="showquotemensaje" />
    
          <hospedaje v-if="showhospedaje" />

    <blogevento
      v-if="showblogevento"
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />

    <hashtagetiqueta  v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)"  /> 


    <carrusel-componente-3 v-if="showcarrusel3" />
    
     
       <Ventanaemergente v-if="showventana" />


     <img_fixed v-if="showimg_fixed" />

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavbarComponent from './narvar.vue';
import BienvenidaPage from './BienvenidaPage.vue';
import imagenprimera from './imagenprimera.vue';
import padresevento from './padresevento.vue';
import dondeycuando from './dondeycuando.vue';
import itinerario from './itinerario.vue';
import mensajeregalos from './mensajeregalos.vue';
import InvitadoEvento from './invitado_evento.vue';
import confirmacionasistencia from './confirmaciónasistencia.vue';
import blogevento from './blog_evento.vue';
import quotemensaje from './quotemensaje.vue';
import imgfinal from './imgfinal.vue';
import img_fixed from './img_fixed.vue';
import musicaFondo from './musica_fondo.vue';
import contador from './contador.vue';
import imgfinal2 from './solofaltan.vue';
import mesaRegalos from './regalos';
import codigovestimenta from './codigovestimenta.vue';
import carruselComponente3 from './carruselComponente-3.vue';
import hashtagetiqueta from './hashtag_etiqueta.vue';
import carrusel from './carruselComponent.vue'
import carrusel2 from './Carrusel-Component-2.vue';
import Ventanaemergente from './ventanaemergente.vue';
import fondocambiante from './fondocambiante.vue';
import hospedaje from './hospedaje.vue';
export default {
  name: 'BaseB',
  components: {
    NavbarComponent,
    BienvenidaPage,
    padresevento,
    imagenprimera,
    carrusel,
    dondeycuando,
    fondocambiante,
    itinerario,
    carrusel2,
    mensajeregalos,
    carruselComponente3,
    mesaRegalos,
    hashtagetiqueta,
    hospedaje,
    codigovestimenta,
    InvitadoEvento,
    confirmacionasistencia,
    quotemensaje,
    contador,
    imgfinal2,
    blogevento,
    imgfinal,
    Ventanaemergente,
    img_fixed,
    musicaFondo,
  },
  setup() {
    const showNavbar = ref(false);
    const showBienvenida = ref(false);
    const showimagenprimera=ref(false);
    const showpadresevento=ref(false);
    const showdondeycuando=ref(false);
    const showitinerario=ref(false);
    const showmensajeregalos=ref(false);
    const showmesaRegalos=ref(false);
    const showInvitadoEvento=ref(false);
    const showfondocambiente=ref(false);
    const showconfirmacionasistencia=ref(false);
    const showcontador= ref(false);
    const showquotemensaje=ref(false);
    const showblogevento=ref(false);
    const showimgfinal=ref(false);
    const showimg_fixed=ref(false);
    const showmusicaFondo=ref(false);
    const showventana=ref(false);
    const showcarrusel3=ref(false);
    const showhashtag=ref(false);
    const showhospedaje=ref(false);
    const showimgfinal2=ref(false);
    const showcarrusel=ref(false);
    const showcodigovestimenta=ref(false);
    const showcarrusel2=ref(false);

    // Obtener el parámetro idInvitado de la ruta
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined); // Si no hay parámetro, es undefined
    const idFestejado = ref(Number(route.params.idFestejado) || undefined); // Si no hay parámetro, es undefined
    const nombreVariable = ref(route.params.nombre) ;

    // Verificar si el idInvitado es válido (no NaN o undefined)
    const isValidIdInvitado = computed(() => {
      return !isNaN(idInvitado.value) && idInvitado.value !== undefined;
    });

    const isValidFestejado = computed(() => {
      return !isNaN(idIFestejado.value) && idFestejado.value !== undefined;
    });


    // Observa los cambios en la ruta para actualizar idInvitado
    watch(() => route.params.idInvitado, (newId) => {
  idInvitado.value = Number(newId);
});

watch(() => route.params.idFestejado, (newId) => {
  idFestejado.value = Number(newId);
});
watch(() => route.params.nombre, (newId) => {
  nombreVariable.value = (newId);
});

    const handleClick = () => {
      console.log('idInvitado:', idInvitado.value); // Verifica el valor aquí
      console.log('idFestejado:', idFestejado.value); // Verifica el valor aquí
      console.log('NOMBRE:', nombreVariable.value); // Verifica el valor aquí

      showNavbar.value = true;
      showBienvenida.value = true;
      showimagenprimera.value=true;
      showpadresevento.value=true;
      showdondeycuando.value = true;
      showitinerario.value = true;
      showimgfinal2.value=true;
      showventana.value=true;
      showfondocambiente.value=true;
      showmensajeregalos.value = true;
      showmesaRegalos.value=true;
      showhashtag.value=true;
      showcarrusel.value=true;
      showInvitadoEvento.value = true;
      showhospedaje.value=true;
      showconfirmacionasistencia.value = true;
      showquotemensaje.value=true;
      showblogevento.value=true;
      showcarrusel3.value=true;
      showcontador.value=true;
      showimgfinal.value=true;
      showcarrusel2.value=true;
      showcodigovestimenta.value=true;
      showimg_fixed.value = true;
      showmusicaFondo.value=true;
    };

    onMounted(() => {
      document.addEventListener('click', handleClick);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClick);
    });

    return {
      showNavbar,
      showBienvenida,
      showdondeycuando,
      showitinerario,
      showmesaRegalos,
      showInvitadoEvento,
      showimgfinal2,
      showfondocambiente,
      showconfirmacionasistencia,
      showquotemensaje,
      showblogevento,
      showimgfinal,
      showcarrusel2,
      showimg_fixed,
      showhashtag,
      showcarrusel3,
      showcodigovestimenta,
      showmusicaFondo,
      showcarrusel,
      idInvitado,
      isValidIdInvitado, 
      idFestejado,
      nombreVariable,
      isValidFestejado, // Computed que indica si el idInvitado es válido
      handleClick,
    };
  }
};
</script>

<style scoped>
/* Estilos globales para el contenedor */
</style>
